import styles from '../cssModules/index.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Form } from 'react-bootstrap';


export function WalletRepeat({ prod, setProdInfo, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const outMaterial = ['Leather', 'Polyester', 'Nylon', 'ABS', 'Canvas',
        'Fabric', 'Felt', 'Metal', 'Polycarbonate', 'Polypropylene',
        'Synthetic'
    ];

    const walletCompType = [
        'Credit Card',
        'Coin',
        'Paper Money',
        'Checkbook',
        'ID Card',
        'Business Card',
        'Key',
        'Passport',
        'Photo',
        'SD Card',
        'Vaccine Card'
    ]

    const foamFactor = [
        'Bi-Fold',
        'Coat',
        'Continental',
        'Envelope',
        'French',
        'Slim',
        'Tri-Fold'
    ]

    const specialFeature = [
        'Anti-Magnetic Lining',
        'Automatic Lock',
        'Bifold',
        'Card Holder',
        'Coin Slot',
        'Compact',
        'Convertible',
        'Crush Proof',
        'Detachable Strap',
        'Dust Resistant',
        'Expandable',
        'Fade Resistant',
        'Fire Resistant',
        'Front Pocket',
        'ID Window',
        'Lightweight',
        'Money Clip',
        'Passport Holder',
        'Pen Holder',
        'Phone Holder',
        'Photo Slot',
        'Pop-Up',
        'RFID Protected',
        'Scan Proof',
        'Scratch Resistant',
        'Secret Compartment',
        'Smart Wallet',
        'Spacious',
        'Stain Resistant',
        'Thin',
        'Thumb Notch',
        'Trifold',
        'Water Resistant',
        'Waterproof',
        'Wristlet Strap',
        'None'
    ];


    const pocketDesc = [
        'Coin Pocket',
        'Zip Pocket',
        'Slip Pocket',
        'Flap Pocket',
        'Slash Pocket',
        'Slide Pocket',
        'Slit Pocket',
        'Stash Pocket'
    ]

    const style = [
        'Airplane',
        'Alien',
        'Animals',
        'Anime',
        'Beach',
        'Bicycle',
        'Birds',
        'Cars',
        'Cartoon',
        'Comic',
        'Dance',
        'Emoticon',
        'Fantasy',
        'Flags',
        'Floral',
        'Gun',
        'Love',
        'Meme',
        'Military',
        'Monster',
        'Motorcycle',
        'Movies',
        'Music',
        'Nautical',
        'Religion',
        'Skull',
        'Space',
        'Sports',
        'Superhero',
        'Unicorn'
    ];

    const careInstruction = [
        'Dry Cloth Clean',
        'Hand Wash',
        'Machine Wash',
        'Wet Wipe Clean'
    ]

    const liningDesc = [
        'Leather',
        'Faux Leather',
        'Polyester',
        'Aluminium',
        'Carbon Fibre',
        'Cotton',
        'Cotton Blend',
        'Linen',
        'Mesh',
        'Metal',
        'Nylon',
        'Plastic',
        'Polycotton',
        'Polyurethane',
        'Polyvinyl Chloride (PVC)',
        'Rubber',
        'Silk',
        'Stainless Steel',
        'Suede',
        'Vinyl'
    ];

    const userSegment = ['Men', 'Women'];

    const color = ['red', 'darkred', 'tan', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const design = [
        'Solid',
        'Floral',
        'Geometric',
        'Abstract',
        'Animal Print',
        'Argyle',
        'Camouflage',
        'Checkered',
        'Chevron',
        'Gingham',
        'Hearts',
        'Herringbone',
        'Houndstooth',
        'Ikat',
        'Letter Print',
        'Marble',
        'Moire',
        'Paisley',
        'Plaid',
        'Polka Dots',
        'Quilted',
        'Star',
        'String',
        'Striped',
        'Tie-Dye',
    ];

    const closureType = [
        'Snap',
        'Zipper',
        'Button',
        'Buckle',
        'Flap',
        'Hook and Loop',
        'Kiss-Lock',
        'Lobster Clasp',
        'Magnetic',
        'Pushlock',
        'Turnlock'
    ];

    const includedComponent = [
        'Keychain',
        'Removable Pouch',
        'Chain',
        'Lanyard',
        'Adjustable Strap',
        'Removable ID Window',
        'Wrist Strap',
        'None'
    ];

    const size = ['Small', 'Medium', 'Large'];

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)'];

    const stock = ['In stock', 'Out of stock'];

    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 700000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });
            formData.append('product', JSON.stringify(prod));

            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        // let data = await response.json();
                        // let prodId = data['prodId'];
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProdInfo(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod.additionsize && (
                <div className={`${styles.sellerUploadmainDiv}`}>
                    <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                        <div className={`${styles.sellerUploadDiv}`}>
                            <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph1'>
                                        Choose photo 1
                                    </label>
                                    <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph2'>
                                        Choose photo 2
                                    </label>
                                    <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph3'>
                                        Choose photo 3
                                    </label>
                                    <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph4'>
                                        Choose photo 4
                                    </label>
                                    <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph5'>
                                        Choose photo 5
                                    </label>
                                    <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                                </div>
                            </div>
                            <div className={`${styles.selleruploadFormDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='outMaterial'>
                                        Outer Material Type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='outMaterial' required name='outMaterial' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.outMaterial} selected hidden>{prod.outMaterial}</option>
                                        {outMaterial.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='walletCompType'>
                                        Wallet Compartment Type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='walletCompType' name='walletCompType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.walletCompType} selected hidden>{prod.walletCompType}</option>
                                        {walletCompType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='userSegment'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='userSegment' name='userSegment' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='foamFactor'>
                                        Foam Factor
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='foamFactor' name='foamFactor' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.foamFactor} selected hidden>{prod.foamFactor}</option>
                                        {foamFactor.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='pocketDescription'>
                                        Pocket Description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='pocketDescription' required name='pocketDescription' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.pocketDescription} selected hidden>{prod.pocketDescription}</option>
                                        {pocketDesc.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' required name='closureType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.closureType} selected hidden>{prod.closureType}</option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='specialFeature'>
                                        Special feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='specialFeature' required name='specialFeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.specialFeature} selected hidden>{prod.specialFeature}</option>
                                        {specialFeature.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='careInstruction'>
                                        Care Instruction
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='careInstruction' required name='careInstruction' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                        {careInstruction.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='style'>
                                        Style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='style' required name='style' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.style} selected hidden>{prod.style}</option>
                                        {style.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='design'>
                                        Design
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.design} selected hidden>{prod.design}</option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='liningDesc'>
                                        Lining description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='liningDesc' required name='liningDesc' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.liningDesc} selected hidden>{prod.liningDesc}</option>
                                        {liningDesc.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='includedComponent'>
                                        Included component
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='includedComponent' required name='includedComponent' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.includedComponent} selected hidden>{prod.includedComponent}</option>
                                        {includedComponent.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='name'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required
                                        defaultValue={prod.name}
                                        type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='price'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required
                                        defaultValue={prod.oldPrice}
                                        type='number' placeholder="price" name='oldPrice' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='discountP'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='discountP'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required
                                        defaultValue={prod.currentPrice}
                                        type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock'
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required
                                        defaultValue={prod.stock}
                                        type='number' placeholder="Total stock available" name='stock' />
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Size</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true}
                                        type='text'
                                        placeholder="SKU"
                                        name='sku' />
                                </div>
                            </div>
                        </div>
                        <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                        <button className={`${styles.uploadRepeat}`}
                            onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                    </form >
                </div >)
            }
        </>
    )
}